export interface GlideAppIconData {
    readonly name: string;
    readonly path: string;
    readonly category: string;
    readonly metadata: readonly string[];
}

export const GLIDE_APP_ICONS: readonly GlideAppIconData[] = [
    {
        name: "st-message-circle",
        path: `/svg/stroke/st-message-circle.svg`,
        metadata: ["message", "circle", "bubble", "chat"],
        category: "Essentials",
    },
    { name: "st-user", path: `/svg/stroke/st-user.svg`, metadata: ["user", "person"], category: "Essentials" },
    {
        name: "st-mail",
        path: `/svg/stroke/st-mail.svg`,
        metadata: ["mail", "email", "message", "enveloppe"],
        category: "Essentials",
    },
    {
        name: "st-action-bolt",
        path: `/svg/stroke/st-action-bolt.svg`,
        metadata: ["action", "bolt"],
        category: "Essentials",
    },
    {
        name: "st-components",
        path: `/svg/stroke/st-components.svg`,
        metadata: ["components", "dashboard", "squares", "grid"],
        category: "Essentials",
    },
    {
        name: "st-chart",
        path: `/svg/stroke/st-chart.svg`,
        metadata: ["chart", "pie", "distribution"],
        category: "Essentials",
    },
    {
        name: "st-locked",
        path: `/svg/stroke/st-locked.svg`,
        metadata: ["locked", "lock", "security", "private"],
        category: "Essentials",
    },
    {
        name: "st-language-website",
        path: `/svg/stroke/st-language-website.svg`,
        metadata: ["language", "website", "globe", "network"],
        category: "Essentials",
    },
    {
        name: "st-upload",
        path: `/svg/stroke/st-upload.svg`,
        metadata: ["upload", "cloud", "import", "export"],
        category: "Essentials",
    },
    { name: "st-star-5", path: `/svg/stroke/st-star-5.svg`, metadata: ["star", "favorite"], category: "Essentials" },
    {
        name: "st-eye",
        path: `/svg/stroke/st-eye.svg`,
        metadata: ["eye", "vision", "hide", "view"],
        category: "Essentials",
    },
    {
        name: "st-settings",
        path: `/svg/stroke/st-settings.svg`,
        metadata: ["settings", "cog", "parameters", "advanced"],
        category: "Essentials",
    },
    {
        name: "st-edit-pencil",
        path: `/svg/stroke/st-edit-pencil.svg`,
        metadata: ["edit", "pencil", "pen", "form", "write"],
        category: "Essentials",
    },
    { name: "st-grid", path: `/svg/stroke/st-grid.svg`, metadata: ["grid", "data"], category: "Essentials" },
    {
        name: "st-users",
        path: `/svg/stroke/st-users.svg`,
        metadata: ["users", "persons", "group", "team"],
        category: "Essentials",
    },
    {
        name: "st-video",
        path: `/svg/stroke/st-video.svg`,
        metadata: ["video", "youtube", "play"],
        category: "Essentials",
    },
    {
        name: "st-burger",
        path: `/svg/stroke/st-burger.svg`,
        metadata: ["burger", "menu", "lines"],
        category: "Essentials",
    },
    { name: "st-plus-add", path: `/svg/stroke/st-plus-add.svg`, metadata: ["plus", "add"], category: "Essentials" },
    { name: "st-search", path: `/svg/stroke/st-search.svg`, metadata: ["search"], category: "Essentials" },
    {
        name: "st-check",
        path: `/svg/stroke/st-check.svg`,
        metadata: ["check", "done", "validate"],
        category: "Essentials",
    },
    {
        name: "st-check-circle",
        path: `/svg/stroke/st-check-circle.svg`,
        metadata: ["check", "circle", "done", "validate"],
        category: "Essentials",
    },
    {
        name: "st-gague",
        path: `/svg/stroke/st-gague.svg`,
        metadata: ["gague", "dashboard", "performance"],
        category: "Essentials",
    },
    {
        name: "st-house",
        path: `/svg/stroke/st-house.svg`,
        metadata: ["house", "home", "overview"],
        category: "Essentials",
    },
    {
        name: "st-heart",
        path: `/svg/stroke/st-heart.svg`,
        metadata: ["heart", "favourite", "matt"],
        category: "Essentials",
    },
    {
        name: "st-more",
        path: `/svg/stroke/st-more.svg`,
        metadata: ["more", "menu", "options"],
        category: "Essentials",
    },
    {
        name: "st-light-bulb",
        path: `/svg/stroke/st-light-bulb.svg`,
        metadata: ["light", "bulb", "idea", "light"],
        category: "Objects",
    },
    {
        name: "st-research-lab",
        path: `/svg/stroke/st-research-lab.svg`,
        metadata: ["research", "lab", "test", "explore"],
        category: "Objects",
    },
    { name: "st-flag", path: `/svg/stroke/st-flag.svg`, metadata: ["flag", "mark"], category: "Objects" },
    {
        name: "st-guide-book",
        path: `/svg/stroke/st-guide-book.svg`,
        metadata: ["guide", "book", "directory", "open", "read"],
        category: "Objects",
    },
    {
        name: "st-tool",
        path: `/svg/stroke/st-tool.svg`,
        metadata: ["tool", "wrench", "parameters", "settings"],
        category: "Objects",
    },
    {
        name: "st-mail-opened",
        path: `/svg/stroke/st-mail-opened.svg`,
        metadata: ["mail", "opened", "view", "read"],
        category: "Objects",
    },
    {
        name: "st-unlocked",
        path: `/svg/stroke/st-unlocked.svg`,
        metadata: ["unlocked", "unlock", "access"],
        category: "Objects",
    },
    { name: "st-trash", path: `/svg/stroke/st-trash.svg`, metadata: ["trash", "delete", "bin"], category: "Objects" },
    {
        name: "st-filter",
        path: `/svg/stroke/st-filter.svg`,
        metadata: ["filter", "parameters", "settings"],
        category: "Objects",
    },
    {
        name: "st-design-brush",
        path: `/svg/stroke/st-design-brush.svg`,
        metadata: ["design", "brush", "paint", "edit"],
        category: "Objects",
    },
    {
        name: "st-bird-house",
        path: `/svg/stroke/st-bird-house.svg`,
        metadata: ["bird", "house", "home"],
        category: "Objects",
    },
    {
        name: "st-clock",
        path: `/svg/stroke/st-clock.svg`,
        metadata: ["clock", "snooze", "time", "watch"],
        category: "Objects",
    },
    {
        name: "st-folder",
        path: `/svg/stroke/st-folder.svg`,
        metadata: ["folder", "group"],
        category: "Objects",
    },
    {
        name: "st-image",
        path: `/svg/stroke/st-image.svg`,
        metadata: ["image", "picture", "photo", "frame", "upload"],
        category: "Objects",
    },
    {
        name: "st-link",
        path: `/svg/stroke/st-link.svg`,
        metadata: ["link", "url", "website"],
        category: "Communication",
    },
    {
        name: "st-share",
        path: `/svg/stroke/st-share.svg`,
        metadata: ["share", "connect", "connections"],
        category: "Communication",
    },
    {
        name: "st-help",
        path: `/svg/stroke/st-help.svg`,
        metadata: ["help", "question", "question", "mark"],
        category: "Communication",
    },
    {
        name: "st-info-circle",
        path: `/svg/stroke/st-info-circle.svg`,
        metadata: ["info", "circle", "information"],
        category: "Communication",
    },
    {
        name: "st-edit-notebook",
        path: `/svg/stroke/st-edit-notebook.svg`,
        metadata: ["edit", "notebook", "write", "compose"],
        category: "Communication",
    },
    {
        name: "st-message-square",
        path: `/svg/stroke/st-message-square.svg`,
        metadata: ["message", "square", "bubble", "chat"],
        category: "Communication",
    },
    {
        name: "st-send",
        path: `/svg/stroke/st-send.svg`,
        metadata: ["send", "compose", "email"],
        category: "Communication",
    },
    {
        name: "st-blog-content",
        path: `/svg/stroke/st-blog-content.svg`,
        metadata: ["blog", "content", "media", "document"],
        category: "Communication",
    },
    {
        name: "st-message-square-chat",
        path: `/svg/stroke/st-message-square-chat.svg`,
        metadata: ["message", "square", "chat", "bubble", "write", "compose"],
        category: "Communication",
    },
    {
        name: "st-message-square-remove",
        path: `/svg/stroke/st-message-square-remove.svg`,
        metadata: ["message", "square", "remove", "delete"],
        category: "Communication",
    },
    {
        name: "st-alert-warning",
        path: `/svg/stroke/st-alert-warning.svg`,
        metadata: ["alert", "warning", "exclamation"],
        category: "Communication",
    },
    {
        name: "st-notification",
        path: `/svg/stroke/st-notification.svg`,
        metadata: ["notification", "alert", "message"],
        category: "Communication",
    },
    {
        name: "st-feature",
        path: `/svg/stroke/st-feature.svg`,
        metadata: ["feature", "new", "notification"],
        category: "Communication",
    },
    {
        name: "st-custom-input",
        path: `/svg/stroke/st-custom-input.svg`,
        metadata: ["custom", "input", "write"],
        category: "Communication",
    },
    {
        name: "st-check-task",
        path: `/svg/stroke/st-check-task.svg`,
        metadata: ["check", "task", "document", "done", "read", "paper"],
        category: "Communication",
    },
    {
        name: "st-edit-content",
        path: `/svg/stroke/st-edit-content.svg`,
        metadata: ["edit", "content", "document", "sheet", "paper", "write", "pencil"],
        category: "Communication",
    },
    {
        name: "st-list",
        path: `/svg/stroke/st-list.svg`,
        metadata: ["list", "text", "left", "align"],
        category: "Communication",
    },
    {
        name: "st-edit-browser",
        path: `/svg/stroke/st-edit-browser.svg`,
        metadata: ["edit", "browser", "pencil"],
        category: "Communication",
    },
    {
        name: "st-compose-mail",
        path: `/svg/stroke/st-compose-mail.svg`,
        metadata: ["compose", "mail", "email"],
        category: "Communication",
    },
    {
        name: "st-mail-opened",
        path: `/svg/stroke/st-mail-opened.svg`,
        metadata: ["mail", "opened", "email", "enveloppe"],
        category: "Communication",
    },
    {
        name: "st-telephone",
        path: `/svg/stroke/st-telephone.svg`,
        metadata: ["telephone", "phone", "call"],
        category: "Communication",
    },
    {
        name: "st-password",
        path: `/svg/stroke/st-password.svg`,
        metadata: ["password"],
        category: "Communication",
    },
    {
        name: "st-facebook",
        path: `/svg/stroke/st-facebook.svg`,
        metadata: ["facebook", "social"],
        category: "Communication",
    },
    {
        name: "st-whatsapp",
        path: `/svg/stroke/st-whatsapp.svg`,
        metadata: ["whatsapp", "social"],
        category: "Communication",
    },
    {
        name: "st-linkedin",
        path: `/svg/stroke/st-linkedin.svg`,
        metadata: ["linkedin", "social"],
        category: "Communication",
    },
    {
        name: "st-twitter",
        path: `/svg/stroke/st-twitter.svg`,
        metadata: ["twitter", "social"],
        category: "Communication",
    },
    {
        name: "st-calendar",
        path: `/svg/stroke/st-calendar.svg`,
        metadata: ["calendar", "event", "schedule"],
        category: "Events & People",
    },
    {
        name: "st-address-book",
        path: `/svg/stroke/st-address-book.svg`,
        metadata: ["address", "book", "directory", "people", "contacts"],
        category: "Events & People",
    },
    {
        name: "st-single-man-flag",
        path: `/svg/stroke/st-single-man-flag.svg`,
        metadata: ["single", "man", "flag", "person"],
        category: "Events & People",
    },
    {
        name: "st-emoji-happy",
        path: `/svg/stroke/st-emoji-happy.svg`,
        metadata: ["emoji", "happy", "face", "laugh"],
        category: "Events & People",
    },
    {
        name: "st-emoji-ok",
        path: `/svg/stroke/st-emoji-ok.svg`,
        metadata: ["emoji", "ok", "face", "smile"],
        category: "Events & People",
    },
    {
        name: "st-emoji-hmm",
        path: `/svg/stroke/st-emoji-hmm.svg`,
        metadata: ["emoji", "hmm", "face", "neutral"],
        category: "Events & People",
    },
    {
        name: "st-emoji-sad",
        path: `/svg/stroke/st-emoji-sad.svg`,
        metadata: ["emoji", "sad", "face"],
        category: "Events & People",
    },
    {
        name: "st-arrow-inspect",
        path: `/svg/stroke/st-arrow-inspect.svg`,
        metadata: ["arrow", "inspect", "circle", "next"],
        category: "Arrows",
    },
    {
        name: "st-sync",
        path: `/svg/stroke/st-sync.svg`,
        metadata: ["sync", "reload", "arrow", "arrows"],
        category: "Arrows",
    },
    {
        name: "st-arrow-reload",
        path: `/svg/stroke/st-arrow-reload.svg`,
        metadata: ["sync", "reload", "arrow", "arrows"],
        category: "Arrows",
    },
    {
        name: "st-arrow-external",
        path: `/svg/stroke/st-arrow-external.svg`,
        metadata: ["arrow", "external", "open", "link"],
        category: "Arrows",
    },
    {
        name: "st-arrow-left",
        path: `/svg/stroke/st-arrow-left.svg`,
        metadata: ["arrow", "left", "previous", "full"],
        category: "Arrows",
    },
    {
        name: "st-arrow-right",
        path: `/svg/stroke/st-arrow-right.svg`,
        metadata: ["arrow", "right", "next", "full"],
        category: "Arrows",
    },
    {
        name: "st-arrow-down",
        path: `/svg/stroke/st-arrow-down.svg`,
        metadata: ["arrow", "down", "import", "download"],
        category: "Arrows",
    },
    {
        name: "st-arrow-up",
        path: `/svg/stroke/st-arrow-up.svg`,
        metadata: ["arrow", "up", "upload"],
        category: "Arrows",
    },
    {
        name: "st-arrow-up-left",
        path: `/svg/stroke/st-arrow-up-left.svg`,
        metadata: ["arrow", "left", "up", "back", "close"],
        category: "Arrows",
    },
    {
        name: "st-arrow-up-right",
        path: `/svg/stroke/st-arrow-up-right.svg`,
        metadata: ["arrow", "right", "up", "external", "link"],
        category: "Arrows",
    },
    {
        name: "st-chevron-selector",
        path: `/svg/stroke/st-chevron-selector.svg`,
        metadata: ["chevron", "selector", "arrows", "up down", "select"],
        category: "Arrows",
    },
    { name: "st-redo", path: `/svg/stroke/st-redo.svg`, metadata: ["arrow", "redo", "next"], category: "Arrows" },
    {
        name: "st-undo",
        path: `/svg/stroke/st-undo.svg`,
        metadata: ["arrow", "undo", "preview", "reply"],
        category: "Arrows",
    },
    {
        name: "st-download",
        path: `/svg/stroke/st-download.svg`,
        metadata: ["arrow", "download", "import", "place"],
        category: "Arrows",
    },
    {
        name: "st-login",
        path: "/svg/stroke/st-login.svg",
        metadata: ["arrow", "login", "enter"],
        category: "Arrows",
    },
    {
        name: "st-sort",
        path: `/svg/stroke/st-sort.svg`,
        metadata: ["arrows", "up down", "filter", "sort"],
        category: "Arrows",
    },
    {
        name: "st-laptop-remote",
        path: `/svg/stroke/st-laptop-remote.svg`,
        metadata: ["laptop", "remote", "pin", "desktop", "computer"],
        category: "Devices",
    },
    {
        name: "st-desktop",
        path: `/svg/stroke/st-desktop.svg`,
        metadata: ["desktop", "device", "monitor", "screen", "large"],
        category: "Devices",
    },
    {
        name: "st-tablet",
        path: `/svg/stroke/st-tablet.svg`,
        metadata: ["tablet", "device", "ipad", "screen", "medium"],
        category: "Devices",
    },
    {
        name: "st-mobile",
        path: `/svg/stroke/st-mobile.svg`,
        metadata: ["mobile", "device", "mobile", "iphone", "call"],
        category: "Devices",
    },
    {
        name: "st-templates",
        path: `/svg/stroke/st-templates.svg`,
        metadata: ["templates", "devices", "mobile"],
        category: "Devices",
    },
    {
        name: "st-briefcase",
        path: `/svg/stroke/st-briefcase.svg`,
        metadata: ["briefcase", "business", "toolbox"],
        category: "Business",
    },
    {
        name: "st-buildings-business",
        path: `/svg/stroke/st-buildings-business.svg`,
        metadata: ["buildings", "business", "enterprise"],
        category: "Business",
    },
    {
        name: "st-trolley-cart",
        path: `/svg/stroke/st-trolley-cart.svg`,
        metadata: ["trolley", "cart", "shop", ", "],
        category: "Business",
    },
    {
        name: "st-data",
        path: `/svg/stroke/st-data.svg`,
        metadata: ["data", "grid", "table", ", "],
        category: "Business",
    },
    {
        name: "st-pin",
        path: `/svg/stroke/st-pin.svg`,
        metadata: ["pin", "place", "map", ", "],
        category: "Maps & Travel",
    },
    {
        name: "st-luggage",
        path: `/svg/stroke/st-luggage.svg`,
        metadata: ["luggage", "case", "travel"],
        category: "Maps & Travel",
    },
    {
        name: "st-wellbeing-peace",
        path: `/svg/stroke/st-wellbeing-peace.svg`,
        metadata: ["wellbeing", "peace", "balance"],
        category: "Maps & Travel",
    },
    {
        name: "st-snorkle",
        path: `/svg/stroke/st-snorkle.svg`,
        metadata: ["snorkle", "face"],
        category: "Maps & Travel",
    },
    {
        name: "st-rocket",
        path: `/svg/stroke/st-rocket.svg`,
        metadata: ["rocket", "launch"],
        category: "Maps & Travel",
    },
    {
        name: "st-globe",
        path: `/svg/stroke/st-globe.svg`,
        metadata: ["globe", "earth", "planet", ", "],
        category: "Maps & Travel",
    },
    {
        name: "st-network-pin",
        path: `/svg/stroke/st-network-pin.svg`,
        metadata: ["globe", "earth", "planet", "place", "pin", "location"],
        category: "Maps & Travel",
    },
    { name: "st-checkbox", path: `/svg/stroke/st-checkbox.svg`, metadata: ["square", "squircle"], category: "Shapes" },
    { name: "st-radio", path: `/svg/stroke/st-radio.svg`, metadata: ["circle", "round"], category: "Shapes" },
    { name: "st-stairs", path: `/svg/stroke/st-stairs.svg`, metadata: ["stairs", "steps"], category: "Shapes" },
    { name: "st-apps", path: `/svg/stroke/st-apps.svg`, metadata: ["apps", "app", "square"], category: "Shapes" },
    { name: "st-pages", path: `/svg/stroke/st-pages.svg`, metadata: ["pages", "screen", "large"], category: "Shapes" },
    {
        name: "st-products",
        path: `/svg/stroke/st-products.svg`,
        metadata: ["products", "overlap", "duplicate"],
        category: "Shapes",
    },
    {
        name: "st-copy",
        path: `/svg/stroke/st-copy.svg`,
        metadata: ["copy", "duplicate", "squares"],
        category: "Shapes",
    },
    { name: "st-star-4", path: `/svg/stroke/st-star-4.svg`, metadata: ["star", "4", "new"], category: "Shapes" },
    {
        name: "st-shield-security",
        path: `/svg/stroke/st-shield-security.svg`,
        metadata: ["shield", "security", "privacy"],
        category: "Shapes",
    },
    { name: "st-bap", path: `/svg/stroke/st-bap.svg`, metadata: ["bap", "exlamation", "asterisk"], category: "Shapes" },
    { name: "st-close", path: `/svg/stroke/st-close.svg`, metadata: ["close", "delete", "x"], category: "Shapes" },
    { name: "st-null", path: `/svg/stroke/st-null.svg`, metadata: ["minus", "null", "less"], category: "Shapes" },
    {
        name: "st-sso",
        path: `/svg/stroke/st-sso.svg`,
        metadata: ["sso"],
        category: "Communication",
    },
    {
        name: "st-at",
        path: `/svg/stroke/st-at.svg`,
        metadata: ["at", "email", "mention"],
        category: "Communication",
    },
    {
        name: "st-chart-up",
        path: `/svg/stroke/st-chart-up.svg`,
        metadata: ["chart", "up", "growth"],
        category: "Business",
    },
    {
        name: "st-chart",
        path: `/svg/stroke/st-chart.svg`,
        metadata: ["chart", "graph", "data"],
        category: "Business",
    },
    {
        name: "st-circle-strike",
        path: `/svg/stroke/st-circle-strike.svg`,
        metadata: ["circle", "strike", "cross"],
        category: "Essentials",
    },
    {
        name: "st-clipboard",
        path: `/svg/stroke/st-clipboard.svg`,
        metadata: ["clipboard", "document", "sheet", "paper"],
        category: "Communication",
    },
    {
        name: "st-condition",
        path: `/svg/stroke/st-condition.svg`,
        metadata: ["condition", "if", "else"],
        category: "Arrows",
    },
    {
        name: "st-credit-card",
        path: `/svg/stroke/st-credit-card.svg`,
        metadata: ["credit", "card", "payment"],
        category: "Business",
    },
    {
        name: "st-database-server",
        path: `/svg/stroke/st-database-server.svg`,
        metadata: ["database", "server", "data"],
        category: "Devices",
    },
    {
        name: "st-diagram",
        path: `/svg/stroke/st-diagram.svg`,
        metadata: ["diagram", "flow", "chart"],
        category: "Business",
    },
    {
        name: "st-workflow",
        path: `/svg/stroke/st-workflow.svg`,
        metadata: ["workflow", "flow", "diagram"],
        category: "Business",
    },
    {
        name: "st-dial",
        path: `/svg/stroke/st-dial.svg`,
        metadata: ["dial", "phone", "buttons"],
        category: "Communication",
    },
    {
        name: "st-hand-grab-gesture",
        path: `/svg/stroke/st-hand-grab-gesture.svg`,
        metadata: ["hand", "grab", "gesture"],
        category: "Events & People",
    },
    {
        name: "st-help-donut",
        path: `/svg/stroke/st-help-donut.svg`,
        metadata: ["help", "donut"],
        category: "Objects",
    },
    {
        name: "st-microphone",
        path: `/svg/stroke/st-microphone.svg`,
        metadata: ["microphone", "voice", "sound"],
        category: "Communication",
    },
    {
        name: "st-sun",
        path: `/svg/stroke/st-sun.svg`,
        metadata: ["sun", "day", "light"],
        category: "Maps & Travel",
    },
    {
        name: "st-moon",
        path: `/svg/stroke/st-moon.svg`,
        metadata: ["moon", "night", "dark"],
        category: "Maps & Travel",
    },
    {
        name: "st-navigation",
        path: `/svg/stroke/st-navigation.svg`,
        metadata: ["pointer", "mouse", "click"],
        category: "Arrows",
    },
    {
        name: "st-offline",
        path: `/svg/stroke/st-offline.svg`,
        metadata: ["offline", "disconnected", "cloud"],
        category: "Communication",
    },
    {
        name: "st-play",
        path: `/svg/stroke/st-play.svg`,
        metadata: ["play", "start", "video"],
        category: "Essentials",
    },
    {
        name: "st-pause",
        path: `/svg/stroke/st-pause.svg`,
        metadata: ["pause", "stop", "play"],
        category: "Essentials",
    },
    {
        name: "st-play-sound",
        path: `/svg/stroke/st-play-sound.svg`,
        metadata: ["play", "sound", "audio"],
        category: "Communication",
    },
    {
        name: "st-scan-barcode",
        path: `/svg/stroke/st-scan-barcode.svg`,
        metadata: ["scan", "barcode", "qr"],
        category: "Devices",
    },
    {
        name: "st-shuffle",
        path: `/svg/stroke/st-shuffle.svg`,
        metadata: ["shuffle", "random", "play"],
        category: "Arrows",
    },
    {
        name: "st-signature",
        path: "/svg/stroke/st-signature.svg",
        metadata: ["signature", "sign", "hand"],
        category: "Communication",
    },
    {
        name: "st-sound",
        path: `/svg/stroke/st-sound.svg`,
        metadata: ["sound", "audio", "volume"],
        category: "Communication",
    },
    {
        name: "st-sound-off",
        path: `/svg/stroke/st-sound-off.svg`,
        metadata: ["sound", "audio", "volume", "mute"],
        category: "Communication",
    },
    {
        name: "st-truck",
        path: `/svg/stroke/st-truck.svg`,
        metadata: ["truck", "delivery", "transport"],
        category: "Maps & Travel",
    },
    {
        name: "st-verified",
        path: `/svg/stroke/st-verified.svg`,
        metadata: ["verified", "check", "done"],
        category: "Objects",
    },
    {
        name: "st-workflow-delete-row",
        path: `/svg/stroke/st-workflow-delete-row.svg`,
        metadata: ["delete", "remove"],
        category: "Essentials",
    },
    {
        name: "st-attach-paperclip",
        path: `/svg/stroke/st-attach-paperclip.svg`,
        metadata: ["attach", "paperclip", "attachment"],
        category: "Communication",
    },
    {
        name: "st-thumbs-up-like",
        path: `/svg/stroke/st-thumbs-up-like.svg`,
        metadata: ["thumbs", "up", "like", "hand"],
        category: "Events & People",
    },
    {
        name: "st-thumbs-down-dislike",
        path: `/svg/stroke/st-thumbs-down-dislike.svg`,
        metadata: ["thumbs", "down", "dislike", "hand"],
        category: "Events & People",
    },
    {
        name: "st-calendar-days",
        path: `/svg/stroke/st-calendar-days.svg`,
        metadata: ["calendar", "days", "event", "schedule"],
        category: "Essentials",
    },
    {
        name: "st-checklist",
        path: `/svg/stroke/st-checklist.svg`,
        metadata: ["checklist", "list", "task"],
        category: "Essentials",
    },
    {
        name: "st-medal",
        path: `/svg/stroke/st-medal.svg`,
        metadata: ["medal", "award", "trophy"],
        category: "Essentials",
    },
    {
        name: "st-drawer",
        path: `/svg/stroke/st-drawer.svg`,
        metadata: ["drawer", "folder", "file"],
        category: "Objects",
    },
    {
        name: "st-drawer-2",
        path: `/svg/stroke/st-drawer-2.svg`,
        metadata: ["drawer", "folder", "file"],
        category: "Objects",
    },
    {
        name: "st-toolbox",
        path: `/svg/stroke/st-toolbox.svg`,
        metadata: ["toolbox", "tools", "settings"],
        category: "Objects",
    },
    {
        name: "st-archive",
        path: `/svg/stroke/st-archive.svg`,
        metadata: ["archive", "box", "folder"],
        category: "Objects",
    },
    {
        name: "st-fork-knife",
        path: `/svg/stroke/st-fork-knife.svg`,
        metadata: ["fork", "knife", "food"],
        category: "Objects",
    },
    {
        name: "st-birthday-cake",
        path: `/svg/stroke/st-birthday-cake.svg`,
        metadata: ["birthday", "cake", "celebration"],
        category: "Objects",
    },
    {
        name: "st-bottle",
        path: `/svg/stroke/st-bottle.svg`,
        metadata: ["bottle", "drink", "water"],
        category: "Objects",
    },
    {
        name: "st-growth",
        path: `/svg/stroke/st-growth.svg`,
        metadata: ["growth", "up", "increase", "plant"],
        category: "Objects",
    },
    {
        name: "st-fashion",
        path: `/svg/stroke/st-fashion.svg`,
        metadata: ["fashion", "clothes", "dress"],
        category: "Objects",
    },
    {
        name: "st-umbrella",
        path: `/svg/stroke/st-umbrella.svg`,
        metadata: ["umbrella", "rain", "weather"],
        category: "Objects",
    },
    {
        name: "st-gift",
        path: `/svg/stroke/st-gift.svg`,
        metadata: ["gift", "present", "box"],
        category: "Objects",
    },
    {
        name: "st-chair",
        path: `/svg/stroke/st-chair.svg`,
        metadata: ["chair", "seat", "furniture"],
        category: "Objects",
    },
    {
        name: "st-door-hanger",
        path: `/svg/stroke/st-door-hanger.svg`,
        metadata: ["door", "hanger", "sign", "label"],
        category: "Objects",
    },
    {
        name: "st-medicine-pill",
        path: `/svg/stroke/st-medicine-pill.svg`,
        metadata: ["medicine", "pill", "health"],
        category: "Objects",
    },
    {
        name: "st-parasol",
        path: `/svg/stroke/st-parasol.svg`,
        metadata: ["parasol", "umbrella", "sun"],
        category: "Objects",
    },
    {
        name: "st-spectacles",
        path: `/svg/stroke/st-spectacles.svg`,
        metadata: ["spectacles", "glasses", "eye"],
        category: "Objects",
    },
    {
        name: "st-shopping-bag",
        path: `/svg/stroke/st-shopping-bag.svg`,
        metadata: ["shopping", "bag", "cart"],
        category: "Objects",
    },
    {
        name: "st-eraser",
        path: `/svg/stroke/st-eraser.svg`,
        metadata: ["eraser", "delete", "remove"],
        category: "Objects",
    },
    {
        name: "st-hammer",
        path: `/svg/stroke/st-hammer.svg`,
        metadata: ["hammer", "tool", "settings"],
        category: "Objects",
    },
    {
        name: "st-fan",
        path: `/svg/stroke/st-fan.svg`,
        metadata: ["fan", "air", "wind"],
        category: "Objects",
    },
    {
        name: "st-charging-station",
        path: `/svg/stroke/st-charging-station.svg`,
        metadata: ["charging", "station", "battery"],
        category: "Objects",
    },
    {
        name: "st-gas",
        path: `/svg/stroke/st-gas.svg`,
        metadata: ["gas", "fuel", "energy"],
        category: "Objects",
    },
    {
        name: "st-ruler",
        path: `/svg/stroke/st-ruler.svg`,
        metadata: ["ruler", "measure", "length"],
        category: "Objects",
    },
    {
        name: "st-hamburger",
        path: `/svg/stroke/st-hamburger.svg`,
        metadata: ["hamburger", "burger", "food"],
        category: "Objects",
    },
    {
        name: "st-drink",
        path: `/svg/stroke/st-drink.svg`,
        metadata: ["drink", "cup", "beverage"],
        category: "Objects",
    },
    {
        name: "st-dices",
        path: `/svg/stroke/st-dices.svg`,
        metadata: ["dices", "game", "chance"],
        category: "Objects",
    },
    {
        name: "st-american-football",
        path: `/svg/stroke/st-american-football.svg`,
        metadata: ["american", "football", "game"],
        category: "Objects",
    },
    {
        name: "st-basketball",
        path: `/svg/stroke/st-basketball.svg`,
        metadata: ["basketball", "game", "sport"],
        category: "Objects",
    },
    {
        name: "st-apple",
        path: `/svg/stroke/st-apple.svg`,
        metadata: ["apple", "fruit", "food"],
        category: "Objects",
    },
    {
        name: "st-armchair",
        path: `/svg/stroke/st-armchair.svg`,
        metadata: ["armchair", "chair", "seat"],
        category: "Objects",
    },
    {
        name: "st-balloon",
        path: `/svg/stroke/st-balloon.svg`,
        metadata: ["balloon", "party", "celebration"],
        category: "Objects",
    },
    {
        name: "st-crown",
        path: `/svg/stroke/st-crown.svg`,
        metadata: ["crown", "king", "queen"],
        category: "Objects",
    },
    {
        name: "st-drop",
        path: `/svg/stroke/st-drop.svg`,
        metadata: ["drop", "water", "liquid"],
        category: "Objects",
    },
    {
        name: "st-fire",
        path: `/svg/stroke/st-fire.svg`,
        metadata: ["fire", "flame", "burn"],
        category: "Objects",
    },
    {
        name: "st-stopwatch",
        path: `/svg/stroke/st-stopwatch.svg`,
        metadata: ["stopwatch", "timer", "clock"],
        category: "Objects",
    },
    {
        name: "st-scissors",
        path: `/svg/stroke/st-scissors.svg`,
        metadata: ["scissors", "cut", "tool"],
        category: "Objects",
    },
    {
        name: "st-settings-gear",
        path: `/svg/stroke/st-settings-gear.svg`,
        metadata: ["settings", "gear", "tool"],
        category: "Objects",
    },
    {
        name: "st-knob",
        path: `/svg/stroke/st-knob.svg`,
        metadata: ["knob", "settings", "tool"],
        category: "Objects",
    },
    {
        name: "st-diamond-shine",
        path: "/svg/stroke/st-diamond-shine.svg",
        metadata: ["diamond", "shine", "gem"],
        category: "Objects",
    },
    {
        name: "st-megaphone",
        path: `/svg/stroke/st-megaphone.svg`,
        metadata: ["megaphone", "loudspeaker", "sound"],
        category: "Communication",
    },
    {
        name: "st-newspaper-3",
        path: `/svg/stroke/st-newspaper-3.svg`,
        metadata: ["newspaper", "news", "media"],
        category: "Communication",
    },
    {
        name: "st-newspaper",
        path: `/svg/stroke/st-newspaper.svg`,
        metadata: ["newspaper", "news", "media"],
        category: "Communication",
    },
    {
        name: "st-write",
        path: `/svg/stroke/st-write.svg`,
        metadata: ["write", "compose", "edit"],
        category: "Communication",
    },
    {
        name: "st-pencil-wave",
        path: `/svg/stroke/st-pencil-wave.svg`,
        metadata: ["pencil", "wave", "write"],
        category: "Communication",
    },
    {
        name: "st-signal-tower",
        path: `/svg/stroke/st-signal-tower.svg`,
        metadata: ["signal", "tower", "network"],
        category: "Communication",
    },
    {
        name: "st-hashtag",
        path: `/svg/stroke/st-hashtag.svg`,
        metadata: ["hashtag", "pound", "number"],
        category: "Communication",
    },
    {
        name: "st-cloud-sync",
        path: `/svg/stroke/st-cloud-sync.svg`,
        metadata: ["cloud", "sync", "reload"],
        category: "Communication",
    },
    {
        name: "st-cloud-check",
        path: `/svg/stroke/st-cloud-check.svg`,
        metadata: ["cloud", "check", "done"],
        category: "Communication",
    },
    {
        name: "st-cloud-download",
        path: `/svg/stroke/st-cloud-download.svg`,
        metadata: ["cloud", "download", "import"],
        category: "Communication",
    },
    {
        name: "st-code-lines",
        path: `/svg/stroke/st-code-lines.svg`,
        metadata: ["code", "lines", "programming"],
        category: "Communication",
    },
    {
        name: "st-airplay-audio",
        path: `/svg/stroke/st-airplay-audio.svg`,
        metadata: ["airplay", "audio", "sound"],
        category: "Communication",
    },
    {
        name: "st-square-lines-bottom",
        path: `/svg/stroke/st-square-lines-bottom.svg`,
        metadata: ["square", "lines", "bottom"],
        category: "Communication",
    },
    {
        name: "st-audio",
        path: `/svg/stroke/st-audio.svg`,
        metadata: ["audio", "sound", "music"],
        category: "Communication",
    },
    {
        name: "st-raising-hand-4-finger",
        path: `/svg/stroke/st-raising-hand-4-finger.svg`,
        metadata: ["hand", "gesture", "raise"],
        category: "Events & People",
    },
    {
        name: "st-pointer",
        path: `/svg/stroke/st-pointer.svg`,
        metadata: ["pointer", "mouse", "click"],
        category: "Events & People",
    },
    {
        name: "st-brain",
        path: `/svg/stroke/st-brain.svg`,
        metadata: ["brain", "mind", "thought"],
        category: "Events & People",
    },
    {
        name: "st-finger-print",
        path: `/svg/stroke/st-finger-print.svg`,
        metadata: ["finger", "print", "biometrics"],
        category: "Events & People",
    },
    {
        name: "st-arrow-share-left",
        path: `/svg/stroke/st-arrow-share-left.svg`,
        metadata: ["arrow", "share", "left"],
        category: "Arrows",
    },
    {
        name: "st-arrow-share-right",
        path: `/svg/stroke/st-arrow-share-right.svg`,
        metadata: ["arrow", "share", "right"],
        category: "Arrows",
    },
    {
        name: "st-arrow-triangle-top",
        path: `/svg/stroke/st-arrow-triangle-top.svg`,
        metadata: ["arrow", "triangle", "top"],
        category: "Arrows",
    },
    {
        name: "st-arrow-triangle-bottom",
        path: `/svg/stroke/st-arrow-triangle-bottom.svg`,
        metadata: ["arrow", "triangle", "bottom"],
        category: "Arrows",
    },
    {
        name: "st-arrow-triangle-left",
        path: `/svg/stroke/st-arrow-triangle-left.svg`,
        metadata: ["arrow", "triangle", "left"],
        category: "Arrows",
    },
    {
        name: "st-arrow-triangle-right",
        path: `/svg/stroke/st-arrow-triangle-right.svg`,
        metadata: ["arrow", "triangle", "right"],
        category: "Arrows",
    },
    {
        name: "st-arrows-repeat-right-left",
        path: `/svg/stroke/st-arrows-repeat-right-left.svg`,
        metadata: ["arrows", "repeat", "reload", "refresh"],
        category: "Arrows",
    },
    {
        name: "st-arrow-left-x",
        path: `/svg/stroke/st-arrow-left-x.svg`,
        metadata: ["arrow", "left", "x", "cross", "delete"],
        category: "Arrows",
    },
    {
        name: "st-satellite",
        path: `/svg/stroke/st-satellite.svg`,
        metadata: ["satellite", "space", "orbit"],
        category: "Devices",
    },
    {
        name: "st-smartwatch",
        path: `/svg/stroke/st-smartwatch.svg`,
        metadata: ["smartwatch", "device", "screen"],
        category: "Devices",
    },
    {
        name: "st-server",
        path: `/svg/stroke/st-server.svg`,
        metadata: ["server", "computer", "data"],
        category: "Devices",
    },
    {
        name: "st-battery-empty",
        path: `/svg/stroke/st-battery-empty.svg`,
        metadata: ["battery", "empty", "low"],
        category: "Devices",
    },
    {
        name: "st-macbook",
        path: `/svg/stroke/st-macbook.svg`,
        metadata: ["macbook", "laptop", "computer"],
        category: "Devices",
    },
    {
        name: "st-devices",
        path: `/svg/stroke/st-devices.svg`,
        metadata: ["devices", "computer", "desktop"],
        category: "Devices",
    },
    {
        name: "st-ar-cube",
        path: `/svg/stroke/st-ar-cube.svg`,
        metadata: ["ar", "cube", "3d"],
        category: "Devices",
    },
    {
        name: "st-calculator",
        path: `/svg/stroke/st-calculator.svg`,
        metadata: ["calculator", "math", "numbers"],
        category: "Devices",
    },
    {
        name: "st-camera",
        path: `/svg/stroke/st-camera.svg`,
        metadata: ["camera", "photo", "video"],
        category: "Devices",
    },
    {
        name: "st-chip",
        path: `/svg/stroke/st-chip.svg`,
        metadata: ["chip", "computer", "hardware"],
        category: "Devices",
    },
    {
        name: "st-floppy-disk",
        path: `/svg/stroke/st-floppy-disk.svg`,
        metadata: ["floppy", "disk", "save"],
        category: "Devices",
    },
    {
        name: "st-headphones",
        path: `/svg/stroke/st-headphones.svg`,
        metadata: ["headphones", "audio", "sound"],
        category: "Devices",
    },
    {
        name: "st-plugin",
        path: `/svg/stroke/st-plugin.svg`,
        metadata: ["plugin", "connect", "hardware"],
        category: "Devices",
    },
    {
        name: "st-sim-card",
        path: `/svg/stroke/st-sim-card.svg`,
        metadata: ["sim", "card", "mobile", "memory", "sd"],
        category: "Devices",
    },
    {
        name: "st-settings-slider-three",
        path: `/svg/stroke/st-settings-slider-three.svg`,
        metadata: ["settings", "slider", "three"],
        category: "Devices",
    },
    {
        name: "st-formula",
        path: `/svg/stroke/st-formula.svg`,
        metadata: ["formula", "math", "equation"],
        category: "Business",
    },
    {
        name: "st-store",
        path: `/svg/stroke/st-store.svg`,
        metadata: ["store", "shop", "business"],
        category: "Business",
    },
    {
        name: "st-bank",
        path: `/svg/stroke/st-bank.svg`,
        metadata: ["bank", "money", "finance"],
        category: "Business",
    },
    {
        name: "st-block",
        path: `/svg/stroke/st-block.svg`,
        metadata: ["building", "house", "office"],
        category: "Business",
    },
    {
        name: "st-buildings",
        path: `/svg/stroke/st-buildings.svg`,
        metadata: ["buildings", "business", "enterprise"],
        category: "Business",
    },
    {
        name: "st-home-roof",
        path: `/svg/stroke/st-home-roof.svg`,
        metadata: ["home", "roof", "house"],
        category: "Business",
    },
    {
        name: "st-home-round-door",
        path: `/svg/stroke/st-home-round-door.svg`,
        metadata: ["home", "door", "house"],
        category: "Business",
    },
    {
        name: "st-school",
        path: `/svg/stroke/st-school.svg`,
        metadata: ["school", "education", "learning"],
        category: "Business",
    },
    {
        name: "st-power-plant",
        path: `/svg/stroke/st-power-plant.svg`,
        metadata: ["power", "plant", "energy"],
        category: "Business",
    },
    {
        name: "st-chart-2",
        path: `/svg/stroke/st-chart-2.svg`,
        metadata: ["chart", "graph", "data"],
        category: "Business",
    },
    {
        name: "st-chart-3",
        path: `/svg/stroke/st-chart-3.svg`,
        metadata: ["chart", "graph", "data"],
        category: "Business",
    },
    {
        name: "st-money-hand",
        path: `/svg/stroke/st-money-hand.svg`,
        metadata: ["money", "hand", "cash"],
        category: "Business",
    },
    {
        name: "st-coin-dollar",
        path: `/svg/stroke/st-coin-dollar.svg`,
        metadata: ["coin", "dollar", "money"],
        category: "Business",
    },
    {
        name: "st-currency-dollar",
        path: `/svg/stroke/st-currency-dollar.svg`,
        metadata: ["currency", "dollar", "money"],
        category: "Business",
    },
    {
        name: "st-bitcoin",
        path: `/svg/stroke/st-bitcoin.svg`,
        metadata: ["bitcoin", "currency", "money"],
        category: "Business",
    },
    {
        name: "st-crypto-coin",
        path: `/svg/stroke/st-crypto-coin.svg`,
        metadata: ["crypto", "coin", "currency"],
        category: "Business",
    },
    {
        name: "st-ship",
        path: `/svg/stroke/st-ship.svg`,
        metadata: ["ship", "boat", "transport"],
        category: "Maps & Travel",
    },
    {
        name: "st-web3",
        path: `/svg/stroke/st-web3.svg`,
        metadata: ["space", "planet", "web3"],
        category: "Maps & Travel",
    },
    {
        name: "st-world",
        path: `/svg/stroke/st-world.svg`,
        metadata: ["world", "earth", "planet"],
        category: "Maps & Travel",
    },
    {
        name: "st-map",
        path: `/svg/stroke/st-map.svg`,
        metadata: ["map", "location", "place"],
        category: "Maps & Travel",
    },
    {
        name: "st-direction",
        path: `/svg/stroke/st-direction.svg`,
        metadata: ["direction", "arrow", "location"],
        category: "Maps & Travel",
    },
    {
        name: "st-pin-location",
        path: `/svg/stroke/st-pin-location.svg`,
        metadata: ["pin", "location", "place"],
        category: "Maps & Travel",
    },
    {
        name: "st-location",
        path: `/svg/stroke/st-location.svg`,
        metadata: ["location", "pin", "place"],
        category: "Maps & Travel",
    },
    {
        name: "st-airplane-up",
        path: `/svg/stroke/st-airplane-up.svg`,
        metadata: ["airplane", "up", "flight"],
        category: "Maps & Travel",
    },
    {
        name: "st-airplane-down",
        path: `/svg/stroke/st-airplane-down.svg`,
        metadata: ["airplane", "down", "flight"],
        category: "Maps & Travel",
    },
    {
        name: "st-bus",
        path: `/svg/stroke/st-bus.svg`,
        metadata: ["bus", "transport", "vehicle"],
        category: "Maps & Travel",
    },
    {
        name: "st-car",
        path: `/svg/stroke/st-car.svg`,
        metadata: ["car", "transport", "vehicle"],
        category: "Maps & Travel",
    },
    {
        name: "st-car-front-view",
        path: `/svg/stroke/st-car-front-view.svg`,
        metadata: ["car", "front", "vehicle"],
        category: "Maps & Travel",
    },
    {
        name: "st-delivery-bike",
        path: `/svg/stroke/st-delivery-bike.svg`,
        metadata: ["delivery", "bike", "transport"],
        category: "Maps & Travel",
    },
    {
        name: "st-mountain-bike",
        path: `/svg/stroke/st-mountain-bike.svg`,
        metadata: ["mountain", "bike", "transport"],
        category: "Maps & Travel",
    },
    {
        name: "st-roller",
        path: `/svg/stroke/st-roller.svg`,
        metadata: ["roller", "skate", "transport"],
        category: "Maps & Travel",
    },
    {
        name: "st-cube",
        path: `/svg/stroke/st-cube.svg`,
        metadata: ["cube", "3d", "shape"],
        category: "Shapes",
    },
    {
        name: "st-spatial-capture",
        path: `/svg/stroke/st-spatial-capture.svg`,
        metadata: ["spatial", "capture", "3d"],
        category: "Shapes",
    },
    {
        name: "st-apple-intelligence",
        path: `/svg/stroke/st-apple-intelligence.svg`,
        metadata: ["apple", "intelligence", "ai"],
        category: "Shapes",
    },
    {
        name: "st-api-aggregate",
        path: `/svg/stroke/st-api-aggregate.svg`,
        metadata: ["api", "aggregate", "data"],
        category: "Shapes",
    },
    {
        name: "st-coins",
        path: `/svg/stroke/st-coins.svg`,
        metadata: ["coins", "money", "currency"],
        category: "Shapes",
    },
    {
        name: "st-whiteboard",
        path: `/svg/stroke/st-whiteboard.svg`,
        metadata: ["whiteboard", "board", "presentation"],
        category: "Shapes",
    },
    {
        name: "st-variables",
        path: `/svg/stroke/st-variables.svg`,
        metadata: ["variables", "hexagon"],
        category: "Shapes",
    },
    {
        name: "st-colors",
        path: `/svg/stroke/st-colors.svg`,
        metadata: ["colors", "palette", "color"],
        category: "Shapes",
    },
    {
        name: "st-rec-keyframe",
        path: `/svg/stroke/st-rec-keyframe.svg`,
        metadata: ["rec", "keyframe", "video"],
        category: "Shapes",
    },
    {
        name: "st-golden-ratio",
        path: `/svg/stroke/st-golder-ratio.svg`,
        metadata: ["golden", "ratio"],
        category: "Shapes",
    },
    {
        name: "st-components-2",
        path: `/svg/stroke/st-components-2.svg`,
        metadata: ["components", "diamond"],
        category: "Shapes",
    },
    {
        name: "st-layers-two",
        path: `/svg/stroke/st-layers-two.svg`,
        metadata: ["layers", "two", "stack"],
        category: "Shapes",
    },
    {
        name: "st-blossom",
        path: `/svg/stroke/st-blossom.svg`,
        metadata: ["blossom", "flower", "nature"],
        category: "Shapes",
    },
    {
        name: "st-atom",
        path: `/svg/stroke/st-atom.svg`,
        metadata: ["atom", "science", "molecule"],
        category: "Shapes",
    },
    {
        name: "st-circles-three",
        path: `/svg/stroke/st-circles-three.svg`,
        metadata: ["circles", "three", "shapes"],
        category: "Shapes",
    },
];

type IconData = (typeof GLIDE_APP_ICONS)[number];

export function getAppIconPath(icon: IconData): string;
export function getAppIconPath(name: string): string | undefined;
export function getAppIconPath(nameOrIcon: IconData | string): string | undefined {
    const icon = typeof nameOrIcon === "string" ? GLIDE_APP_ICONS.find(i => i.name === nameOrIcon) : nameOrIcon;
    if (icon === undefined) return undefined;
    return `path:${icon.path}`;
}

// Used to return Legacy RemoteIcons. Now only returns Glide icons.
export function getRandomAppIcon(): string {
    const idx = Math.floor(Math.random() * GLIDE_APP_ICONS.length);
    const icon = GLIDE_APP_ICONS[idx];
    return getAppIconPath(icon);
}
